import type { IMilkingProcess } from 'models/MilkingProcess'

/**
 * Mock для превью виджетов AvgConnectTime, AvgMilkingTime.
 */
export const MILKING_PROCESS_STATS_MOCK: IMilkingProcess = {
	stats: {
		am: 45,
		pm: 38,
		night: 22,
		connect_avg: 180,
		milking_avg: 420,
	},
	deviations: [
		{ type: 'issue_pre_milking_treatment', count: 2 },
		{ type: 'issue_stimulation', count: 1 },
	],
}
